import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "src/hooks/useTranslation";
import { OwnerInfoContext, OwnerInfoState, OwnerInfoForm } from "./";
import { usePassportStore } from "src/stores/Passport.store";

export const PassportOwnerInfoForm = observer(() => {
  const translate = useTranslation();
  const passportStore = usePassportStore();
  const state = new OwnerInfoState(translate, passportStore);

  return (
    <OwnerInfoContext.Provider value={state}>
      <OwnerInfoForm />
    </OwnerInfoContext.Provider>
  );
});
